import { render } from "./ManageGallery.vue?vue&type=template&id=513e6d97"
import script from "./ManageGallery.vue?vue&type=script&lang=js"
export * from "./ManageGallery.vue?vue&type=script&lang=js"

import "./ManageGallery.vue?vue&type=style&index=0&id=513e6d97&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__